import styled from "@emotion/styled";
import { colors } from "../../../theme/colors";

export const ContentContainer = styled.div`
  text-align: center;
`;

export const ModalTitle = styled.h2`
  font-family: "Sora", sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: ${colors.text.primary};
  margin: 0 0 12px 0;
`;

export const ModalDescription = styled.p`
  font-family: "Nunito", sans-serif;
  font-size: 16px;
  color: ${colors.text.secondary};
  margin: 0 0 16px 0;
  line-height: 1.5;
`;

export const QRCodeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const QRCodeImage = styled.img`
  width: 250px;
  height: 250px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 250px;
`;

export const ErrorText = styled.p`
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  color: ${colors.status.error};
  margin: 16px 0;
`;

export const ExpirationText = styled.p`
  font-family: "Nunito", sans-serif;
  font-size: 12px;
  color: ${colors.text.secondary};
  margin: 0;
`;

